import { useSearch } from "@sembark-travel/ui/list"
import { ButtonLink, useLocationQuery } from "@sembark-travel/ui/router"
import { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { HotelVouchersList } from "./../../../HotelVouchers"
import { generatePath } from "./../../../router-utils"

export default function HotelVouchers() {
	const [query, setQuery] = useLocationQuery()
	const [params, setParams] = useSearch(query)
	useEffect(() => {
		setQuery(params)
	}, [params, setQuery])
	return (
		<>
			<Helmet>
				<title>Hotel Vouchers</title>
			</Helmet>
			<HotelVouchersList
				params={params}
				setParams={setParams}
				actions={
					<ButtonLink to={generatePath("/hotel-vouchers/new")}>
						New Voucher
					</ButtonLink>
				}
			/>
		</>
	)
}
